import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./hooks/useTheme";
import QuizLanding from "./pages/QuizLanding";
import QuizInstructions from "./pages/QuizInstructions";
import Quiz from "./pages/Quiz";
import Admin from "./pages/Admin";
import Results from "./pages/Results";
import ReportHistory from "./pages/ReportHistory";
import SharedResults from "./pages/SharedResults";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<QuizLanding />} />
              <Route path="/instructions" element={<QuizInstructions />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/results" element={<Results />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/report-history" element={<ReportHistory />} />
              <Route path="/share/:shareId" element={<SharedResults />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
